<template>
	<div class="pt-2">
		<CommonFlame :title="'担当精錬物一覧'">
			<v-row no-gutters justify="end">
				<v-col cols="12" sm="6" md="4" lg="3">
					<v-select
						label="担当者"
						:items="users"
						v-model="user_id"
						class="mt-4"
						item-text="full_name"
						item-value="id"
						outlined
						dense
						hide-details
						@change="setUserId"
						no-data-text="担当者が存在しません"
					/>
				</v-col>
			</v-row>
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="rubber_processes"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="担当精錬物はありません。"
				>
					<template v-slot:item="{ item }">
						<tr class="no-click">
							<td>{{ item.situation_i18n }}</td>
							<td>{{ common.productNumberByOrderIndividualInfo(item.order_individual_info) }}</td>
							<td>
								{{
									item.order_individual_info.ordered_product
										? common.productNameWithSubName(item.order_individual_info.ordered_product)
										: ""
								}}
							</td>
							<td>
								<!-- TODO 紐付くRequirementの納期 -->
							</td>
							<td>{{ common.formatDateWithPlan(item, "start_date", "schedule_start_date") }}</td>
							<td>{{ item.required_amount }}</td>
							<td>{{ item.main_deliverable.amount }}</td>
							<td class="pa-1 text-center">
								<v-btn
									color="secondary"
									@click="
										$router.push({
											name: 'rubber_process_show',
											params: { id: item.id },
										})
									"
									>開始 / 再開</v-btn
								>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import rules from "../../helper/rules"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		CommonFlame,
	},
	data() {
		return {
			users: [],
			user_id: null,
			rubber_processes: [],
			headers: [
				{
					text: "状態",
					value: "situation_i18n",
					width: "100px",
				},
				{
					text: "製品番号",
					value: "product_number",
					width: "150px",
				},
				{
					text: "製品名",
					value: "product_name",
					width: "200px",
				},
				{
					text: "希望納期",
					value: "",
					width: "150px",
				},
				{
					text: "着手日",
					value: "start_date",
					width: "150px",
				},
				{
					text: "数量",
					value: "quantity",
					width: "100px",
				},
				{
					text: "完了数量",
					value: "completed_quantity",
					width: "100px",
				},
				{
					text: "",
					value: "",
					width: "100px",
				},
			],
			common,
			rules,
		}
	},
	mounted() {
		this.user_id = this.$route.query?.id
		this.fetchRubberProcesses(true)
	},
	methods: {
		fetchRubberProcesses(first_visit) {
			const headers = authenticate.setHeader()
			const params = { user_id: this.user_id, first_visit }
			axios
				.get("/erp/v1/rubber_processes/users", {
					params,
					headers,
				})
				.then((res) => {
					this.rubber_processes = res.data.rubber_processes
					if (first_visit) {
						this.user_id = res.data.user_id
						this.users = res.data.users
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setUserId(e) {
			this.user_id = e
			this.fetchRubberProcesses(false)
		},
		processStatus(item) {
			// TODO 表示ステータス
		},
	},
}
</script>
